<template lang="html">
  <div>
    <v-dialog
      v-for="(dialog, i) in dialogs"
      ref="vprompt"
      :key="i"
      v-model="dialog.showDialog"
      :persistent="dialog.modal"
      :width="dialog.width || 'auto '"
      :max-width="dialog.maxWidth || dialog.width || 500"
      scrollable
      @input="outerClose(dialog)"
    >
      <v-card>
        <v-card-title
          v-if="dialog.title"
          :class="dialog.titleClass"
          style="flex-wrap: nowrap"
        >
          <v-icon
            v-if="dialog.titleIcon"
            class="pr-2"
            :class="dialog.titleIconClass"
            :color="dialog.titleIconColor"
          >
            {{ dialog.titleIcon }}
          </v-icon>
          <span>{{ dialog.title }}</span>
        </v-card-title>
        <v-divider v-if="dialog.divider" />
        <template v-if="dialog.text && dialog.isHtml">
          <v-card-text
            :class="dialog.textClass"
            v-html="dialog.text"
          />
        </template>
        <template v-else-if="dialog.text">
          <v-card-text
            :class="dialog.textClass"
          >
            {{ dialog.text }}
          </v-card-text>
        </template>
        <template v-if="dialog.isHtml">
          <v-card-text
            v-for="(message, i2) in dialog.messages"
            :key="i2"
            :class="dialog.textClass"
            v-html="message"
          />
        </template>
        <template v-else>
          <v-card-text
            v-for="(message, i2) in dialog.messages"
            :key="i2"
            :class="dialog.textClass"
          >
            {{ message }}
          </v-card-text>
        </template>
        <template v-for="(message, i2) in dialog.apiMessages">
          <v-card-text
            v-if="message.type === 'HTML'"
            :key="'mt1-'+i2"
            :class="dialog.textClass"
            v-html="message.message"
          />
          <v-chip
            v-else-if="message.type === 'RECORD_LINK' && hasApiMessageLink(message, dialog)"
            :key="'mt2-'+i2"
            small
            :class="apiMessageClass(message, dialog)"
            @click="doApiMessageLink(message, dialog)"
          >
            <v-avatar>
              <v-icon>mdi-open-in-new</v-icon>
            </v-avatar>
            {{ message.message }}
          </v-chip>
          <v-card-text
            v-else
            :key="'mt3-'+i2"
            :class="dialog.textClass"
          >
            {{ message.message }}
          </v-card-text>
        </template>
        <v-radio-group
          v-if="dialog.promptInputType === 'RADIO'"
          v-model="dialog.promptValue"
        >
          <v-radio
            v-for="(promptValue, i2) in dialog.promptValues"
            :key="i2"
            :label="promptValue.text"
            :value="promptValue.value"
          />
        </v-radio-group>
        <v-autocomplete
          v-else-if="dialog.promptInputType === 'SELECT'"
          v-model="dialog.promptValue"
          :label="promptInputLabel"
          :items="dialog.promptValues"
        />
        <v-divider v-if="dialog.divider" />
        <v-card-actions>
          <v-spacer />
          <v-btn
            v-if="dialog.cancelAction"
            :loading="dialog.isLoading"
            :disabled="dialog.disableCancel"
            :class="dialog.cancelClass"
            color="error"
            text
            @click.stop="doAction(dialog.cancelAction, dialog)"
          >
            {{ dialog.cancelText }}
          </v-btn>
          <v-btn
            v-if="dialog.confirmAction && dialog.promptInputType !== 'ACTION_BUTTON'"
            :loading="dialog.isLoading"
            :disabled="dialog.disableConfirm"
            :class="dialog.confirmClass"
            color="primary"
            text
            @click.stop="doAction(dialog.confirmAction, dialog)"
          >
            {{ dialog.confirmText }}
          </v-btn>
          <v-btn
            v-for="(promptValue, i2) in dialog.promptValues.filter(pv => dialog.promptInputType === 'ACTION_BUTTON')"
            :key="i2"
            :loading="dialog.isLoading"
            :disabled="dialog.disableConfirm"
            :class="dialog.confirmClass"
            :color="promptValue.color || 'primary'"
            text
            @click.stop="doPromptButtonAction(dialog.confirmAction, dialog, promptValue.value)"
          >
            {{ promptValue.text }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

function defaultData () {
  return {
    modal: false,
    title: 'Test',
    titleIcon: false,
    titleIconClass: false,
    titleIconColor: '',
    titleClass: 'headline',
    text: null,
    messages: [],
    apiMessages: [],
    isHtml: false,
    textClass: false,
    confirmText: 'Continue',
    confirmClass: false,
    confirmAction: true,
    cancelText: 'Cancel',
    cancelClass: false,
    cancelAction: false,
    showDialog: true,
    weakModal: false,
    requestedShow: true,
    cancelDialog: false,
    disableCancel: false,
    disableConfirm: false,
    promptValues: [],
    promptValue: null,
    promptInputType: null,
    promptInputLabel: null,
    divider: false,
    blockRoute: true,
    width: null,
    maxWidth: null,
    inUse: true
  }
}

export default {
  name: 'VuePrompt',
  components: {
  },
  props: {
    modal: Boolean,
    title: String,
    width: Number,
    titleClass: [Function, String, Object, Array],
    text: String,
    textClass: String,
    confirmText: String,
    confirmClass: [Function, String, Object, Array],
    confirmAction: [Function, Boolean],
    cancelText: String,
    cancelClass: [Function, String, Object, Array],
    cancelAction: [Function, Boolean]
  },
  data () {
    return {
      dialogs: [],
      dialogQue: []
    }
  },
  computed: {
    anyBlockRoute () {
      return !!this.dialogs.find((d) => d.showDialog && d.modal && !d.weakModal)
    },
    anyOpen () {
      return !!this.dialogs.find((d) => d.showDialog)
    },
    topNonModal () {
      const topDialog = this.dialogs.length && this.dialogs[this.dialogs.length - 1]
      return topDialog && !topDialog.modal && topDialog.showDialog ? topDialog : null
    }
  },
  watch: {
    dialogs: {
      handler () {
        for (let i = 0, l = this.dialogs.length; i < l; i += 1) {
          var dialog = this.dialogs[i]
          if (dialog.cancelDialog && dialog.showDialog) {
            dialog.showDialog = false
          }
        }
      },
      deep: true
    }
  },
  mounted () {
    // Register this as out VuePrompt instance
    this.$vPrompt(null, true)
    this.$router.beforeEach((to, from, next) => {
      if (this.closeTopNonModal() || this.anyBlockRoute || this.anyOpen) {
        // Modal dialogs are open.  Don't allow navigation
        next(false)
      } else {
        next()
      }
    })
  },
  methods: {
    hasApiMessageLink (message, dialog) {
      if (typeof dialog.checkApiMessageLink === 'function') {
        return dialog.checkApiMessageLink(message, dialog)
      }
      return false
    },
    doApiMessageLink (message, dialog) {
      if (typeof dialog.doApiMessageLink === 'function') {
        dialog.doApiMessageLink(message, dialog)
      }
    },
    apiMessageClass (message, dialog) {
      const result = {}
      if (dialog.textClass) {
        result[dialog.textClass] = true
      }
      if (this.hasApiMessageLink(message, dialog)) {
        result['ft-record-link'] = true
        result['ft-expand-chip'] = true
        result['ft-link-chip'] = true
      }
      if (typeof dialog.setApiMessageClass === 'function') {
        return dialog.setApiMessageClass(message, dialog, result)
      }
      return result
    },
    doPromptButtonAction (action, dialog, value) {
      dialog.promptValue = value
      this.doAction(action, dialog)
    },
    doAction (action, dialog) {
      var result
      if (typeof action === 'function') {
        result = action(dialog)
      }
      if (!result) {
        this.closeDialog(dialog)
      }
    },
    closeTopNonModal () {
      for (let dialog of this.dialogs) {
        if (dialog.showDialog && dialog.weakModal) dialog.cancel()
      }
      let topNonModal = this.topNonModal
      if (topNonModal) {
        this.closeDialog(topNonModal)
        return true
      }
      return false
    },
    closeDialog (dialog) {
      dialog.showDialog = false
      dialog.inUse = false
      dialog.killAfter = Date.now() + 10
      /*
      if (!this.openNextInQue()) {
        // We have dialog requests in que, but for some reason can't open a dialog
        console.warn('No open dialog ready for que')
      }
      */
    },
    outerClose (dialog) {
      // Dialog was closed by clicking outside dialog
      this.closeDialog(dialog)
    },
    killAll () {
      this.dialogs = []
    },
    closeAll () {
      for (let i = 0, l = this.dialogs.length; i < l; i += 1) {
        this.closeDialog(this.dialogs[i])
      }
    },
    garbageCollection () {
      var killAll = true
      const killList = []
      const now = Date.now()
      for (let i = 0, l = this.dialogs.length; i < l; i += 1) {
        let dialog = this.dialogs[i]
        if (dialog.inUse) {
          return true
        } else if (dialog.killAfter >= now) {
          killAll = false
        } else if (dialog.killAfter < now) {
          killList.push(i)
        }
      }
      // Lazy garbage collection
      if (killAll) {
        this.dialogs = []
      } else {
        for (let i = killList.length - 1; i >= 0; i -= 1) {
          this.dialogs.splice(i, 1)
        }
      }
      return false
    }, /*
    getDialog () {
      // Get open dialog, if any
      for (var i in this.dialogs) {
        var dialog = this.dialogs[i]
        if (!dialog.inUse) {
          return dialog
        }
      }
      return false
    }, */
    buildDialog (dialogRequest) {
      var defaults = defaultData()
      for (var i in defaults) {
        if (dialogRequest[i] === undefined) {
          dialogRequest[i] = defaults[i]
        }
      }
      dialogRequest.inUse = true
      dialogRequest.requestedShow = dialogRequest.showDialog
      dialogRequest.showDialog = false
      dialogRequest.isLoading = false
      dialogRequest.close = () => {
        this.closeDialog(dialogRequest)
      }
      dialogRequest.cancel = () => {
        this.doAction(dialogRequest.cancelAction, dialogRequest)
      }
      return dialogRequest
    },
    queDialog (dialogRequest) {
      this.dialogs.push(this.buildDialog(dialogRequest))
      setTimeout(() => {
        dialogRequest.showDialog = true
        this.garbageCollection()
      }, 0)
    }
  }
}
</script>
<style>
  .dialog .ft-standard-list {
    margin-left: 20px;
  }
</style>
